import Immutable from 'immutable';
import { createImmutableMap } from 'ctm-util-functions';
import qsParser from 'querystring';

export const experimentIDEnum = Object.freeze({
    CTM_REBRAND: 'expCTMRebrand',
    GALAXY_MIGRATION_PHASE_ONE: 'expGalaxyPhaseOne'
});

/**
 * The page reducer used to set and update details like:
 *     - transitioningToNewPage
 *     - showPleaseWait
 *     - location
 *     - title
 *     - vertical name
 * @param {Object} initialState - The initial state.
 * @returns {Immutable.Map} The new state.
 */
const createPageReducer = (initialState = {}) => {
    const immutableInitialState = createImmutableMap(initialState);
    return (state = immutableInitialState, action) => {
        switch (action.type) {
            // TODO move to appropriate place
            case 'SET_THEME': {
                return state.merge({
                    brand: action.theme
                });
            }
            case 'SET_ROUTER_LOCATION': {
                return state.merge({
                    location: Immutable.fromJS({
                        ...action.location,
                        queryParams: qsParser.parse(location.search.substr(1)) || {}
                    }),
                    previousLocation: state.get('location') || null,
                    name: action.name,
                    title: action.title,
                    lastViewedPage: (state.getIn(['location', 'pathname']) || '').split('/').slice(-1)[0]
                });
            }
            case 'SET_EXPERIMENT_ID': {
                return state.merge({ experimentId: action.value });
            }
            case 'SET_EXPERIMENT_DATA': {
                return state.merge({ experimentData: action.value });
            }
            case 'SET_SPLIT_TRAFFIC_ID': {
                return state.merge({ splitTrafficId: action.value });
            }
            case 'SET_PAGE_VALUE': {
                let newState = state.set(action.identifier, action.value);
                if (action.identifier === 'doReload' && action.value) {
                    newState = newState.set('lastViewedPage', newState.get('name'));
                }
                return newState;
            }
            default: {
                return state;
            }
        }
    };
};

export { createPageReducer };
